import { IAlertTypeItemData } from "@home-health-notify/domain";
import AlertMessageType from "./AlertMessageType";
import { ALERT_MESSAGE_TYPE } from "hhn-commons";

export interface AlertTypeDataProps extends IAlertTypeItemData {
  isRead?: boolean;
  onDismiss?: () => void;
}

interface AlertListProps {
  type: ALERT_MESSAGE_TYPE;
  alertTypeData: AlertTypeDataProps[];
  onScroll?: () => Promise<void>;
  isDataLoading?: boolean;
  restTop?: number;
}

function AlertMessagesList({
  type,
  alertTypeData,
  onScroll,
  isDataLoading,
  restTop,
}: AlertListProps) {
  return (
    <AlertMessageType
      type={type}
      alertTypeData={alertTypeData}
      onScroll={onScroll}
      isDataLoading={isDataLoading}
      restTop={restTop}
    />
  );
}

export { AlertMessagesList };
